import LeadGenerationInputs from "@/components/organisms/LeadGenerationInputs";
import { getCDNURL } from "@/shared/utils/commons";
import Image from "next/image";
import React from "react";

interface RightSectionProps {
  isOnlineCoursePlatform: boolean;
  data: {
    headingType: string;
    coverVideo: {
      videoId: string;
      wrapper: string;
    };
    mainHeroHeader?: string;
  };
  isPathWebinar: boolean;
  isWebinarRebeccaSchocker: boolean;
}

export const RightSection: React.FC<RightSectionProps> = ({
  isOnlineCoursePlatform,
  data,
  isPathWebinar,
  isWebinarRebeccaSchocker,
}) => {
  const [isMuted, setIsMuted] = React.useState(true);
  const videoRef = React.useRef<HTMLVideoElement>(null);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };
  const componentMap = {
    onlineCoursePlatform: () => (
      <div>
        <LeadGenerationInputs fullForm={true} ctaText="Request a Demo" />
      </div>
    ),
    affiliate: () => (
      <Image
        src={
          isPathWebinar ? data?.mainHeroHeader ?? "/images/hero.png" : "/images/main-hero-header.png"
        }
        alt="main-hero-header"
        width={500}
        height={500}
      />
    ),
    WebinarRebeccaSchocker: () => (
      <div className="flex w-full flex-col gap-6 overflow-hidden rounded-3xl border shadow-purpleShadow lg:max-w-[50%] p-6 border-grey-2">
        <iframe
          src="https://tally.so/embed/mYMr6W?hideTitle=1&transparentBackground=1&dynamicHeight=1"
          title="Lead generation form"
          style={{
            border: "none",
            borderRadius: "10px",
            width: "100%",
            height: "370px", 
            overflow: "hidden",
          }}
        >
          Loading…
        </iframe>
        <p className="text-center text-sm text-gray-600 mt-0">
          Your information helps us tailor your experience and keep you informed about upcoming offers.
        </p>
      </div>
    ),
    default: () => {
      return (
        <div className="flex w-full flex-col gap-10 overflow-hidden rounded-3xl border border-purple-2 shadow-purpleShadow lg:max-w-[50%]">
          <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
            <video
              ref={videoRef}
              className="absolute top-0 left-0 w-full h-full rounded-3xl"
              autoPlay
              muted
              playsInline
              loop
              poster={getCDNURL() + "graphy-web/videos/graphy-intro-poster.png"}
              preload="metadata"
            >
              <source src={getCDNURL() + "graphy-web/videos/graphy-intro.mp4"} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            
            {/* Mute/Unmute Button */}
            <button
              onClick={toggleMute}
              className="absolute bottom-4 right-4 bg-black bg-opacity-50 hover:bg-opacity-70 text-white p-3 rounded-full transition-all"
              aria-label={isMuted ? "Unmute" : "Mute"}
            >
              {isMuted ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                </svg>
              )}
            </button>
          </div>
        </div>
      );
    },
  };

  
  let activeComponent: keyof typeof componentMap;

  if (isOnlineCoursePlatform) {
    activeComponent = "onlineCoursePlatform";
  } else if (isWebinarRebeccaSchocker) {
    activeComponent = "WebinarRebeccaSchocker";
  } else if (data?.headingType !== "affiliate") {
    activeComponent = "default";
  } else {
    activeComponent = "affiliate";
  }


  const RenderedComponent = componentMap[activeComponent] || componentMap.default;

  return <>{RenderedComponent()}</>;
};

export default RightSection;


